// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-footer-0503{position:fixed;bottom:0;left:0;right:0;background-color:var(--ui-background-color)}`, "",{"version":3,"sources":["webpack://./src/page/tryon/Footer.module.scss"],"names":[],"mappings":"AAAA,oBACE,cAAA,CACA,QAAA,CACA,MAAA,CACA,OAAA,CACA,2CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer-footer-0503`
};
module.exports = ___CSS_LOADER_EXPORT___;
